import React, { useEffect, useState } from 'react';

import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  CardText,
  CardSubtitle,
  Button,
  Container,
  Row,
  Col,
  Input,
  Label,
  Form,
  FormGroup,
} from 'reactstrap';

import axios from 'axios';
import { useForm } from 'react-hook-form';

import { FormError, FormInput } from '../../../components/MyForm';

const Personal = ({
  next_step,
  prev_step,
  first_name,
  last_name,
  company_name,
  set_first_name,
  set_last_name,
  set_company_name,
}) => {
  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'onChange' });

  const [data, set_data] = useState({
    first_name: first_name,
    last_name: last_name,
    company_name: company_name,
  });

  useEffect(() => {}, []);

  return (
    <Container className="mt-3 d-flex justify-content-center align-items-center">
      <Card className="w-50">
        <CardBody>
          <Form
            onSubmit={handleSubmit((data) => {
              console.log('Personal info handleSubmit has been submitted!');
              console.log(data);
              set_first_name(data.first_name);
              set_last_name(data.last_name);
              set_company_name(data.company_name);
              next_step();
            })}
          >
            <Row>
              <Col md="6" sm="12">
                <FormGroup>
                  <FormInput
                    register={register}
                    name="first_name"
                    id="first_name"
                    label="First name"
                    type="text"
                    validation={{
                      required: 'First name can not be empty!',
                      pattern: {
                        value: /^[A-Za-z]+$/i,
                        message: 'Only letters are allowed',
                      },
                      maxLength: {
                        value: 20,
                        message: 'Maximum length is 20 characters',
                      },
                    }}
                    invalid={errors.first_name}
                    defaultValue={data.first_name}
                  />

                  {errors.first_name && (
                    <FormError message={errors.first_name.message} />
                  )}
                </FormGroup>
              </Col>

              <Col md="6" sm="12">
                <FormGroup>
                  <FormInput
                    register={register}
                    name="last_name"
                    id="last_name"
                    label="Last name"
                    type="text"
                    validation={{
                      required: 'Last name can not be empty!',
                      pattern: {
                        value: /^[A-Za-z]+$/i,
                        message: 'Only letters are allowed',
                      },
                      maxLength: {
                        value: 20,
                        message: 'Maximum length is 20 characters',
                      },
                    }}
                    invalid={errors.last_name}
                    defaultValue={data.last_name}
                  />

                  {errors.last_name && (
                    <FormError message={errors.last_name.message} />
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="12" sm="12">
                <FormGroup>
                  <FormInput
                    register={register}
                    name="company_name"
                    id="company_name"
                    label="Company Name"
                    type="text"
                    validation={{
                      required: 'Company name can not be empty!',
                      pattern: {
                        value: /^[A-Za-z0-9\s]+$/i,
                        message: 'Only letters,numbers and spaces are allowed',
                      },
                      maxLength: {
                        value: 20,
                        message: 'Maximum length is 20 characters',
                      },
                    }}
                    invalid={errors.company_name}
                    defaultValue={data.company_name}
                  />

                  {errors.company_name && (
                    <FormError message={errors.company_name.message} />
                  )}
                </FormGroup>
              </Col>
            </Row>

            <div className="d-flex align-items-center justify-content-center">
              <Button color="primary" onClick={prev_step}>
                Go Back
              </Button>
              &nbsp;&nbsp;<Button color="primary">Next</Button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </Container>
  );
};

export default Personal;
